import { BUSINESS_NUMBER_FORMAT } from "@/constants/regex"

export const toCustomerSearchKeyword = (value: string) => {
  let keyword = value
  if (BUSINESS_NUMBER_FORMAT.test(value)) {
    keyword = keyword.replace(/-/g, "")
  }
  return keyword
}
